export default __webpack_public_path__ + "static/media/gallery_09.cc0797f2.jpg";